<script>
export default {
  name: 'PageStats',

  data() {
    return {
      single_stats: [],
      group_stats: []
    }
  },

  created() {
    this.Loading.yes = true

    this.axios.get('/stats')
      .then(response => {
        this.single_stats = response.data.single
        this.group_stats = response.data.group
      })
      .finally(() => (this.Loading.yes = false))
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div class="container">
      <h1 class="title">Stats</h1>

      <div class="columns is-multiline">
        <div class="column is-3"
          v-for="(stat, key) in single_stats"
          :key="key">
          <div class="box">
            <h2 class="is-size-5">{{ key }}</h2>
            <b class="is-size-1">{{ stat }}</b>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  padding: 20px;
}

.column {
  text-align: center;
  word-wrap: break-word;
  word-wrap: break-word;
}

.column .box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PageStats.vue